import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';
import { noop } from 'lodash';
import { IconButton } from 'components';
import { Modal } from 'components/Modal/Modal.component';
import { ButtonV3 } from 'components/ComponentV2';
import CustomInput from 'components/CustomTextInput';
import { CommunityTypes } from 'lib/models/community';
import styles from './MessageModal.module.scss';

interface MessageModalProps {
  isOpen: boolean;
  type?: string;
  isBulkMode: boolean;
  onSendMessage: (message: string) => void;
  onClose: () => void;
  candidateName?: string;
  selectionCount?: number;
}

type CustomInputRef = {
  insertSelect: (defaultValue: string) => void;
  addContent: (defaultValue: string) => void;
};

export const MessageModal: React.FC<MessageModalProps> = (
  props: MessageModalProps
) => {
  const {
    isOpen,
    type,
    candidateName = '',
    onSendMessage,
    onClose,
    selectionCount,
    isBulkMode = false,
  } = props;

  const [message, setMessage] = useState<string>('');
  const customInputRef = useRef<CustomInputRef | null>(null);

  const getCommunityOptionLabel = (option: string) => {
    switch (option) {
      case CommunityTypes.EVENT_VIEWS:
        return 'event viewers';
      case CommunityTypes.PROFILE_VIEWS:
        return 'profile viewers';
      case CommunityTypes.ATTENDEES:
        return 'attendees';
      case CommunityTypes.SUBSCRIBED:
        return 'subscribers';
      default:
        return 'candidates';
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setMessage('');
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className={styles.Message}>
      <div className={cn(styles.MessageModal)}>
        <div className={styles.MessageModalHeader}>
          <p className={styles.title}>
            {isBulkMode ? (
              <>
                Message{' '}
                {getCommunityOptionLabel(type as CommunityTypes) ===
                'subscribers'
                  ? 'Members'
                  : getCommunityOptionLabel(type as CommunityTypes)}
                {selectionCount ? <span>({selectionCount})</span> : null}
              </>
            ) : (
              <>Message {candidateName || 'candidate'}</>
            )}
          </p>
          <IconButton
            size="small"
            iconName="close"
            className={styles.closeIcon}
            onClick={onClose}
          />
        </div>
        <div className={cn(styles.MessageModalContent)}>
          <div className={styles.textEditorWrapper}>
            <CustomInput
              options={[]}
              textAreaClassName={styles.textEditor}
              wrapperClassName={styles.textEditorWrapper}
              ref={customInputRef}
              updateContent={setMessage}
              placeholder={'Write your message...'}
              setIsCursorInside={noop}
            />
          </div>
        </div>
        <div className={styles.MessageModalAction} id="modal-actions">
          <ButtonV3
            color="primary"
            disabled={!message}
            onClick={() => onSendMessage(message)}
          >
            Send
          </ButtonV3>
        </div>
      </div>
    </Modal>
  );
};
